<div class="associations-container dark-mode">

    <div class="row">
        <div class="col-6 col-sm-6 col-md-6 text-end">
            <div class="d-flex" style="gap: 10px">
                <mat-form-field class="mb-2 w-100" appearance="outline" >
                    <mat-icon matPrefix>search</mat-icon>
                    <input type="text" placeholder="Search" matInput [(ngModel)]="pageQuery.search" (keyup)="searchUser($event)">
                    <mat-icon (click)="clearSearch()" *ngIf="showCloseSearch && pageQuery.search.length > 0" class="button-flat" matSuffix>close</mat-icon>
                </mat-form-field>
                <button class="add-new-button" (click)="addNewActivity()" mat-raised-button  >
                    <mat-icon>add</mat-icon>
                    Add New
                </button>
            </div>

        </div>
    </div>


    <div class="table-responsive-dark list-wrapper-bordered-dark">
        <table class="table table-striped table-hover table-borderless ">
            <thead>
            <tr>
                <th class="text-nowrap">Activity Type</th>
                <th class="text-nowrap">Activity Completion Question</th>
                <th class="text-nowrap">Credit Value</th>
                <th class="text-nowrap">Unit Base</th>
                <th class="sticky-action"></th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngIf="activities.length > 0">
                <tr *ngFor="let activity of activities">
                    <td class="text-start">
                        {{activity.activityType}}
                    </td>
                    <td class="text-start">
                        {{activity.completionQuestion}}
                    </td>
                    <td class="text-start">
                        {{activity.ceuValue}}
                    </td>
                    <td class="text-start">
                        {{activity.unitBase}}
                    </td>
                    <td class="text-center p-1 action-column"  style="width: 160px">
                        <div class="d-flex gap-4 justify-content-center">
                            <mat-icon class="text-white mr-2" (click)="detailActivity(activity.id)">arrow_forward</mat-icon>
                            <mat-icon class="mr-2 accent-orange" (click)="editActivity(activity.id)">edit</mat-icon>
                            <mat-icon class="crimson-red" (click)="deleteActivity(activity.id)">delete</mat-icon>
                        </div>

                    </td>
                </tr>
            </ng-container>

            <tr *ngIf="activities.length == 0">
                <td colspan="4" class="text-center">
                    <span>{{tableLoading ? 'Load data...' : 'No Record'}}</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="mt-4" >
        <app-pagination-dark *ngIf="activities.length > 0"
                (goPage)="toPage($event)"
                (goPerPage)="perPageSet($event)"
                [pagesToShow]="showPages"
                [page]="pageNo"
                [perPage]="pageSize"
                [count]="totalRow"></app-pagination-dark>
    </div>
</div>
